import React, { useEffect } from "react";
import { CSSTransition } from "react-transition-group";

const Modal = props => {
  const closeOnEscapeKeyDown = e => {
    if ((e.charCode || e.keyCode) === 27) {
      props.onClose();
    }
  };

  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  }, []);

  return (
    <CSSTransition
      in={props.show}
      unmountOnExit
      timeout={{ enter: 0, exit: 300 }}
    >
      <div className="custom-modal" onClick={props.onClose}>
        <div className="custom-modal-content" onClick={e => e.stopPropagation()}>
          {props.children}
        </div>
      </div>
    </CSSTransition>
  );
};

export default Modal;
